import './SmallLoader.scss';
import { ReactElement } from 'react';
import { S_ClipLoader } from '../../../../design/loaders/clipLoader/S_ClipLoader';

interface ISmallLoaderProps {
  messages: string[];
}

export const SmallLoader = ({ messages }: ISmallLoaderProps): ReactElement => {
  const getSmallLoaderMessages = (): ReactElement[] => {
    return messages.map((text) => (
      <span
        className='metrics-small-loader-message'
        key={text}
      >
        {text}
      </span>
    ));
  };

  return (
    <div className='metrics-small-loader'>
      <S_ClipLoader
        loading={true}
        size={32}
      />
      <div className='metrics-small-loader-messages'>{getSmallLoaderMessages()}</div>
    </div>
  );
};
